import { apiFetchBuyCoinsList, apiFetchPayList, apiFetchUserInfo, apiFetchShopOrder } from '@/api/imee'

import _debounce from 'lodash/debounce'

export const payMixin = {
  data() {
    const query = this.$route.query
    return {
      // 路由信息
      scene: query.scene || null,
      thirdParam: query.thirdParam || null,
      fromCouponId: query.couponRecordId || null,

      // 原生支付信息
      googlePayList: [],
      googleData: {},

      // 用户/商品/支付信息
      userInfo: {},
      coinsProductList: [],
      payMethodList: [],

      // 选中数据
      selectCoinsProduct: null,
      selectGid: null,
      selectProductId: null,
      selectPayType: '',
      selectPayName: null,
      selectChannelIndex: -1,

      // 页面数据加载
      loadingFlag: false,
      // 调用支付加载
      loadingShow: false,

      appInfo: {
        version: ''
      }
    }
  },
  watch: {
    validCouponList: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fetchMaxCoupon(this.selectCoinsProduct, newVal)
        }
      }
    }
  },
  computed: {
    // 格式化goodDesc字符串 用+分割
    handleTipsFormat() {
      return (value) => {
        if (!value) {
          return []
        }

        const disArr = value
          .split('+')
          .filter((v) => !!v)
          .map((strItem, index) => {
            const result = {
              num: '',
              type: '',
              origin: strItem,
              id: `${strItem}${index}`
            }
            if (strItem.indexOf('coin') > -1) {
              result.num = strItem.replace('coin', '')
              result.type = 'coin'
            }
            if (strItem.indexOf('videopass') > -1) {
              result.num = strItem.replace('videopass', '')
              result.type = 'video-pass'
            }
            return result
          })

        return disArr
      }
    }
  },
  methods: {
    // 支付方式-描述样式
    returnDisClass(desc, packageName) {
      if (desc) {
        let className = ''
        switch (packageName) {
          case 'vava':
            className = 'has-dis-green'
            break
          case 'echo':
          case 'joychat':
            className = 'has-dis-lightgreen'
            break
          default:
            className = 'has-dis-green'
        }
        return className
      }
      return ''
    },

    // 整数/100 保留两位小数 后面补零
    returnFloat(val) {
      let num = val / 100
      if (('' + val).slice(-2) == '00') {
        return num + '.00'
      }
      if (('' + val).slice(-1) == '0') {
        return num + '0'
      }
      return num
    },

    // client回调 原生支付商品价格信息
    queryProductListCallback(res) {
      if (res) {
        // 获得各个档位是否有google支付  返回的list
        this.googlePayList = JSON.parse(res)
        this.findProductOriginPayInfo()
      }
    },

    // 查找google pay数据
    findProductOriginPayInfo() {
      if (this.selectProductId) {
        this.googleData = this.googlePayList.filter((item) => {
          return this.selectProductId == item.productId
        })
      }
    },

    // 获取个人信息
    fetchUserInfo() {
      apiFetchUserInfo().then((res) => {
        if (res) {
          this.userInfo = res
        }
      })
    },

    // 获取金额列表
    fetchCoinsList() {
      // 缓存接口数据代码
      const resolveCoinsList = (res, cb) => {
        this.coinsProductList = res.goods

        // 从客户端获取原生支付价格信息
        this.$client.googleProductList(
          res.goods.map((goodItem) => goodItem.productId),
          this.packageName
        )

        // 客户端优惠卷 默认第一个
        if (this.fromCouponId && this.validCouponList.length > 0) {
          const couponData = this.validCouponList.filter((item) => {
            return item.couponRecordId == this.fromCouponId
          })
          const goodData = res.goods.find((i) => {
            return i.amount >= couponData[0].minUseAmount
          })
          this.selectGid = goodData.gid
          this.selectProductId = goodData.productId
          this.fetchMaxCoupon(goodData)
          this.selectCoinsProduct = goodData
        }
        // 其他
        else {
          this.selectGid = res.goods[0].gid
          this.selectProductId = res.goods[0].productId
          this.fetchMaxCoupon(res.goods[0])
          this.selectCoinsProduct = res.goods[0]
        }
        cb && cb()
      }

      this.loadingFlag = true
      // 读取web localstorage缓存
      const localRes = window.localStorage.getItem('buyCoinsList')
      if (localRes) {
        resolveCoinsList(JSON.parse(localRes), () => {
          this.getPayList(this.selectGid)
        })
      }
      // 加个参数 scene
      apiFetchBuyCoinsList({ scene: this.scene }).then((res) => {
        if (res && res.goods && res.goods.length > 0) {
          // 写入web localstorage缓存
          window.localStorage.setItem('buyCoinsList', JSON.stringify(res))
          resolveCoinsList(res, () => {
            this.getPayList(this.selectGid)
          })
        }
      })
    },

    // 获取支付列表
    getPayList(id) {
      // 缓存接口数据代码
      const resolvePayList = (res) => {
        this.payMethodList = res.payChannelList
        if (this.payMethodList && this.payMethodList.length > 0) {
          this.selectPayType = this.payMethodList[0].payType
        }
        this.loadingFlag = false
      }
      // 读取web localstorage缓存
      const localRes = window.localStorage.getItem('payChannelList')
      if (localRes) {
        resolvePayList(JSON.parse(localRes))
      }
      // 读取接口数据
      if (!id) {
        return
      }
      let params = {
        gid: id,
        shopType: 5,
        scene: 'WebStore'
      }
      apiFetchPayList(params).then((res) => {
        if (res && res.payChannelList) {
          // 写入web localstorage缓存
          window.localStorage.setItem('payChannelList', JSON.stringify(res))
          resolvePayList(res)
        }
      })
    },

    // 选择充值金额
    handleSelectCoins(item) {
      this.fetchMaxCoupon(item)
      this.selectCoinsProduct = item
      this.$client.addEvent('top_up', { Action: 'Click', APosition: 'goods', AValue: item.gid, goodtype: 'coin', productID: item.gid, from: 'webstore' })
      this.selectGid = item.gid
      this.selectProductId = item.productId
      this.payMethodList = item.channels
      if (this.payMethodList && this.payMethodList.length > 0) {
        this.selectPayType = this.payMethodList[0].payType
      }
      this.findProductOriginPayInfo()
    },

    // 选择付款方式
    handleSelectPay(item, index) {
      this.selectPayType = item.payType
      this.selectPayName = item.name
      this.selectChannelIndex = index
      this.thirdPay(item)
    },

    // 支付
    thirdPay: _debounce(
      function (item, cpf) {
        let payChannelTotal = null
        if (this.payMethodList && this.payMethodList.length) {
          payChannelTotal = this.payMethodList.length
        }
        let payChannelIndex = null
        if (this.selectChannelIndex != -1 && payChannelTotal !== null && payChannelTotal !== 0) {
          payChannelIndex = payChannelTotal - 1 - this.selectChannelIndex
        }
        if (this.googleData && this.googleData[0] && payChannelTotal !== null && payChannelIndex !== null) {
          payChannelTotal = payChannelTotal + 1
          payChannelIndex = payChannelIndex + 1
        }

        this.$client.addEvent('top_up', {
          Action: 'Click',
          APosition: 'payButton',
          productID: this.selectGid,
          goodtype: 'coin',
          from: 'webstore',
          paymethod: this.selectMethod
        })
        let data = {
          gid: this.selectGid,
          payType: this.selectPayType,
          scene: this.scene || 'WebStore',
          thirdParam: this.thirdParam,
          shopType: 5,
          payChannel: this.selectPayName,
          payChannelIndex: payChannelIndex,
          payChannelTotal: payChannelTotal
        }
        if (this.$route.query.videoChatScene) {
          data.videoChatScene = this.$route.query.videoChatScene
        }
        if (this.$route.query.activityType) {
          data.activityType = this.$route.query.activityType
        }
        if (this.maxCoupon && this.maxCoupon.couponRecordId) {
          data.couponRecordId = this.maxCoupon.couponRecordId
        }

        if (this.loadingShow === true) {
          return
        }

        this.loadingShow = true

        apiFetchShopOrder(data)
          .then((res) => {
            // 下单后刷新优惠券
            this.fetchCouponList(0)
            if (res) {
              this.order = res.credential && res.credential.wapUrl
              if (res.credential.openInExternalBrowser) {
                this.appAction('open_web_outside', `?url=${res.credential.wapUrl}`)
              }
              //
              else {
                if (this.order) {
                  this.$router.push({
                    path: '/pay-code',
                    query: {
                      url: this.order
                    }
                  })
                }
              }
            }
          })
          .catch(() => {})
          .finally(() => {
            this.loadingShow = false
          })
      },
      2000,
      {
        leading: true,
        trailing: false
      }
    ),

    // 原生支付
    originPay() {
      let params = {
        gid: this.selectGid,
        productId: this.googleData && this.googleData[0].productId,
        scene: this.scene || 'WebStore'
      }

      // 使用优惠券
      if (this.maxCoupon && this.maxCoupon.couponRecordId) {
        params.couponRecordId = this.maxCoupon.couponRecordId
      }

      // 这里的客户端方法 PayNext 和 PayStore 不一样
      payGoogleFromWeb.postMessage(JSON.stringify(params))
    },

    // 关闭结果弹窗
    cancelAgain() {
      this.showResultDia = false
      this.fetchUserInfo()
    },

    // 客户端原生支付完成回调
    refresh() {
      // 用户信息
      this.fetchUserInfo()
      // 有效优惠劵
      this.fetchCouponList(0)
      // 档位列表
      this.fetchCoinsList()
    }
  },
  created() {
    this.appInfo = this.$client.getAppInfo() || { version: '' }
    this.refresh()
    this.$client.addEvent('top_up', { Action: 'Popup', APosition: 'webStore', AValue: this.$route.query.scene })
  },
  mounted() {
    window.refresh = this.refresh
    // 不同点
    window.queryGoogleProductListCallback = this.queryProductListCallback

    // mock 原生支付
    // this.googleData = [
    //   {
    //     price: 1.99
    //   }
    // ]
  }
}
